import { ShipmentsActionTypes } from './constants';

type ShipmentsAction = { type: string, payload: {} | string };

export const shipmentsApiResponseSuccess = (actionType: string, data: any): ShipmentsAction => ({
    type: ShipmentsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const shipmentsApiResponseError = (actionType: string, error: string): ShipmentsAction => ({
    type: ShipmentsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getAllShipments = (query): ShipmentsAction => ({
    type: ShipmentsActionTypes.GET_ALL_SHIPMENTS,
    payload: { query },
});

export const getShipmentSurcharges = (query): ShipmentsAction => ({
    type: ShipmentsActionTypes.GET_SHIPMENT_SURCHARGES,
    payload: { query },
});

export const getNonShipmentSurcharges = (query): ShipmentsAction => ({
    type: ShipmentsActionTypes.GET_NON_SHIPMENT_SURCHARGES,
    payload: { query },
});

export const getShipmentByExternalOrderId = (externalOrderId: string): ShipmentsAction => ({
    type: ShipmentsActionTypes.GET_SHIPMENT_BY_EXTERNAL_ORDER_ID,
    payload: { externalOrderId },
});

export const shipmentsGetOrder = (orderId: string, returnLabel: Boolean, fullResponse: Boolean): ShipmentsAction => ({
    type: ShipmentsActionTypes.GET_ORDER,
    payload: { orderId, returnLabel, fullResponse },
});

export const shipmentsCreateManifest = (manifestSpec: any, returnImage: Boolean, fullResponse: Boolean): ShipmentsAction => ({
    type: ShipmentsActionTypes.CREATE_MANIFEST,
    payload: { manifestSpec, returnImage, fullResponse },
});

export const getAllShipmentsReport = (query): ShipmentsAction => ({
    type: ShipmentsActionTypes.GET_ALL_SHIPMENTS_REPORT,
    payload: { query },
});

export const rateShipments = (query): ShipmentsAction => ({
    type: ShipmentsActionTypes.RATE_SHIPMENTS,
    payload: { query },
});

export const shipmentsResetState = (): ShipmentsAction => ({
    type: ShipmentsActionTypes.RESET_STATE,
    payload: {},
});

export const shipmentsResetAllErrors = (): ShipmentsAction => ({
    type: ShipmentsActionTypes.RESET_ALL_ERRORS,
    payload: {},
});
